import { colors } from '../theme/colors';

export type TimeSmIconProps = {
  size?: { width: number; height: number };
};

export default function TimeSm({ size = { width: 16, height: 16 } }: TimeSmIconProps) {
  return (
    <svg
      width={`${size.width}`}
      height={`${size.height}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15C4.16193 15 1 11.8396 1 7.99669C1 4.16044 4.1553 1 8 1C11.8381 1 15 4.16044 15 7.99669C15 11.8396 11.8447 15 8 15ZM4.85133 9.01041H8C8.35795 9.01041 8.63636 8.72551 8.63636 8.36772V4.24657C8.63636 3.88878 8.35795 3.61051 8 3.61051C7.64205 3.61051 7.35701 3.88878 7.35701 4.24657V7.73166H4.85133C4.49337 7.73166 4.21496 8.00994 4.21496 8.36772C4.21496 8.72551 4.49337 9.01041 4.85133 9.01041Z"
        fill={colors.green40}
      />
    </svg>
  );
}
